// Example usage:
// <div data-controller="tooltip" data-tooltip-content="Hello world"></div>

import { Controller } from "@hotwired/stimulus"

import tippy from "tippy.js"

export default class extends Controller {
  static values = {
    content: String
  }

  connect() {
    let options = {
      allowHTML: true,
      animation: 'rotate'
    }

    if (this.hasContentValue) {
      options['content'] = `<div class="tooltip">${this.contentValue}</div>`
    }

    this.tippy = tippy(this.element, options)
  }

  disconnect() {
    this.tippy.destroy()
  }
}
